import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditChargingstationProfileDialogContentComponent } from './edit-chargingstationprofile-dialog-content/edit-chargingstationprofile-dialog-content.component';
import { RouteDataService } from '../../../services/route-data/route-data.service';
import { AuthenticationService } from '../../../services/authentication/authentication.service';

@Component({
  selector: 'app-edit-chargingstationprofile-dialog',
  template: ''
})
export class EditChargingStationProfileDialogComponent implements OnInit {

  public isOperatorView: boolean;
  public user: boolean = false;
  public customer: boolean = false;
  public operator: boolean = false;
  public size: string = 'xl';
  private sortParam;

  constructor(
    public dialog: NgbModal,
    private activatedRoute: ActivatedRoute,
    private routeDataService: RouteDataService,
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.getRoles();
    this.activatedRoute.paramMap.subscribe(params => {
      this.routeDataService.params = this.activatedRoute.snapshot.params;
      this.openDialog();
    });

  }

  getRoles() {
    if (this.authenticationService.userHasRole('Customer')) {
      this.customer = true;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.operator = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.user = true;
      // this.size = 'md';
    }
  }


  openDialog(): void {
    var profileId = this.routeDataService.params;
    const dialogRef = this.dialog.open(EditChargingstationProfileDialogContentComponent, { size: this.size, backdrop: 'static', keyboard: false });

    dialogRef.componentInstance.profileId = profileId;

    if (this.operator) {
      this.isOperatorView = true;
      dialogRef.componentInstance.isOperatorView = true;
    }

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute, queryParams: { sort: this.sortParam } });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute, queryParams: { sort: this.sortParam } });
    });
  }

}
